<template>
  <div class="robot-arm-setting" v-show="visible">
    <div class="enable-robot-arm">
      <span id="span_cb9ieec7ri" class="color-o-9 mr16 fs14">{{
        $translateLang('启用机械臂对接')
      }}</span>
      <a-switch
        :id="`${idPrefix}switch`"
        :checked="enable"
        @change="handleEnableChange"
      ></a-switch>
      <span id="span_youz774lfc" class="ml20 color-o-4"
        >({{
          $translateLang('开启后，输出生产文件时，会输出机械臂对接文件')
        }})</span
      >
    </div>
    <div class="mt20" v-show="enable">
      <span id="span_6g8aglses2" class="fs14 color-o-9"
        >{{ $translateLang('生成文件类型') }}：</span
      >
      <a-select
        :id="`${idPrefix}model_select`"
        :value="roboticArmModel"
        style="width: 200px"
        show-search
        :filter-option="filterRoboticOption"
        @change="handleSelectChange"
      >
        <a-select-option
          v-for="item in roboticOptions"
          :key="item.value"
          :value="item.value"
          :id="`${idPrefix}file_option_${item.value}`"
          >{{ item.label }}</a-select-option
        >
      </a-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否展示该设置项
    visible: {
      type: Boolean,
      default: true,
    },
    enable: {
      type: Boolean,
      default: false,
    },
    roboticArmModel: {
      type: String,
      default: '',
    },
    // 机械臂模板列表，由 robotArmDocking.vue 统一加载后传入
    roboticOptions: {
      type: Array,
      default: () => [],
    },
    // 埋点id前缀
    idPrefix: {
      type: String,
      default: 'engraving_setting_robot_arm_',
    },
  },
  methods: {
    handleEnableChange(value) {
      this.$emit('update:enable', value)
    },
    handleSelectChange(value) {
      this.$emit('update:robotic-arm-model', value)
    },
    filterRoboticOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>

<style lang="less" scoped>
.robot-arm-setting {
  .enable-robot-arm {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
